import styled from 'styled-components';

export const Label = styled.label`
    display: block;
    font-weight: 600;
    font-size: 11px;
    margin-bottom: ${props => props.margen_abajo?props.margen_abajo:'7'}px;
`;

export const LabelForm = styled.label`
    display: inline-block;
    font-size: 11px;
    @media(min-width: 800px){
        margin-left: ${props => props.margen_izq?props.margen_izq:'0'}px;
    }
    color: ${props => props.color?props.color:'black'};
    margin-top: ${props => props.margen_arriba?props.margen_arriba:'0'}px;
    margin-bottom: ${props => props.margen_abajo?props.margen_abajo:'0'}px;
`;

export const LabelSub = styled.label`
    display: block;
    font-weight: 600;
    font-size: 9px;
    color: ${props => props.color?props.color:'black'};
`;

export const LabelNormal = Label.extend`
    font-weight: normal;
    text-align: justify;
`;

export const LabelRadio = styled.label`
    display: inline-block;
    font-weight: 500;
    font-size: 11px;
    margin-right: 15px;
`;

export const LabelKey = styled.label` 
    font-size: 11px;    
    display: block;
    text-align: left;
    color: black;
`;

export const LabelValor = styled.label`
    display: block;
    font-size: 11px;
    text-align: left;
    color: black;
    font-weight: 500;
`;

export const LabelNota = styled.label`
    display: block;
    font-size: 10px;
    font-style: italic;
    color: green;
    font-family: Calibri;
`;

export const LabelNotaConEstilo = styled.label`
    display: block;
    font-size: ${props => props.fontSize?props.fontSize:'10'}px;    
    color: red;
    font-family: Calibri;
`;

export const LabelCabecera = styled.label`
    display: inline;
    font-size: 10px;
    color: ${props => props.color?props.color:'green'};
    margin-right: ${props => props.margenderecha?props.derecha:'15'}px;
    float: ${props => props.alineacion?props.alineacion:'right'};
    margin-top: ${props => props.margen_arriba?props.margen_arriba:'3px'}'px';
    margin-bottom: ${props => props.margen_abajo?props.margen_abajo:'0px'}'px';
`;

export const LabelTotales = styled.label`
  display: inline-block;
  font-size: 11px;
  color: green;
`;

export const LabelValorTotales = styled.label`
  display: inline-block;
  font-size: 11px;
  font-weight: bold;
`;